/**
 * 工人管理服务
 */
import api from './api';
import {
  Worker,
  CreateWorkerData,
  UpdateWorkerData,
  WorkerQueryParams,
  WorkerStats,
  InsuranceAlert,
  ApiResponse,
  PaginatedResponse
} from '../types';

export class WorkerService {
  private static readonly BASE_PATH = '/worker-module/workers';

  /**
   * 获取工人列表
   */
  static async getWorkers(params?: WorkerQueryParams): Promise<PaginatedResponse<Worker>> {
    const response = await api.get(this.BASE_PATH, { params });
    return response;
  }

  /**
   * 获取工人详情
   */
  static async getWorkerById(id: string): Promise<ApiResponse<Worker>> {
    const response = await api.get(`${this.BASE_PATH}/${id}`);
    return response;
  }

  /**
   * 创建工人
   */
  static async createWorker(data: CreateWorkerData): Promise<ApiResponse<Worker>> {
    const response = await api.post(this.BASE_PATH, data);
    return response;
  }

  /**
   * 更新工人信息
   */
  static async updateWorker(id: string, data: UpdateWorkerData): Promise<ApiResponse<Worker>> {
    const response = await api.put(`${this.BASE_PATH}/${id}`, data);
    return response;
  }

  /**
   * 删除工人
   */
  static async deleteWorker(id: string): Promise<ApiResponse> {
    const response = await api.delete(`${this.BASE_PATH}/${id}`);
    return response;
  }

  /**
   * 获取工人统计数据
   */
  static async getWorkerStats(): Promise<ApiResponse<WorkerStats>> {
    const response = await api.get(`${this.BASE_PATH}/stats/summary`);
    return response;
  }

  /**
   * 获取保险提醒列表
   */
  static async getInsuranceAlerts(days: number = 30): Promise<ApiResponse<InsuranceAlert[]>> {
    const response = await api.get(`${this.BASE_PATH}/insurance/alerts`, { params: { days } });
    return response;
  }

  /**
   * 搜索工人（用于选择器）
   */
  static async searchWorkers(keyword: string): Promise<ApiResponse<Worker[]>> {
    const response = await api.get(`${this.BASE_PATH}/search`, { params: { keyword, limit: 20 } });
    return response;
  }

  /**
   * 获取所有工人（用于选择器）
   */
  static async getAllWorkers(): Promise<ApiResponse<Worker[]>> {
    const response = await api.get(`${this.BASE_PATH}`, { params: { page: 1, limit: 1000 } });
    // 从分页响应中提取数据
    if (response.success && response.data) {
      return {
        success: true,
        data: (response.data as any).workers || (response.data as any).items || response.data
      };
    }
    return response;
  }

  /**
   * 获取负责人列表（具有"leader"或"admin"角色的工人）
   */
  static async getLeaders(): Promise<ApiResponse<Worker[]>> {
    const response = await api.get(`${this.BASE_PATH}/leaders`);
    return response;
  }

  /**
   * 批量导入工人
   */
  static async importWorkers(data: CreateWorkerData[]): Promise<ApiResponse> {
    const response = await api.post(`${this.BASE_PATH}/batch`, { workers: data });
    return response;
  }
}

